import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({ id: 'metrics' });

export const alarmsRouteRef = createRouteRef({ id: 'alarms' });
export const entityAlarmsRouteRef = createRouteRef({ id: 'entity-alarms' });
